import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet";
import "./style.css";
import Banner from "./Banner";
import MediaCenter from "./MediaCenter";
import Leadership from "./Leadership";
import OurBoard from "./OurBoard";
import Projects from "./Projects";
import WhoWeAre from "./WhoWeAre";

const Home = () => {
	const { t } = useTranslation();
	return (
		<div className="home-page">
			<Helmet>
				<title>
					{t("afkar")} | {t("home")}
				</title>
			</Helmet>
			<Banner />
			<Projects />
			<WhoWeAre />
			<OurBoard />
			<Leadership />
			<MediaCenter />
		</div>
	);
};
export default Home;
